import { render } from "./Factories.vue?vue&type=template&id=9146d7b2"
import script from "./Factories.vue?vue&type=script&lang=js"
export * from "./Factories.vue?vue&type=script&lang=js"

import exportComponent from "/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__